import { GalleryProps } from '../types'

export const generateTypes = (galleryProps: GalleryProps): string[] => {
  const listTypes: string[] = []

  galleryProps.gallery.forEach(({ type }) => {
    if (type.length > 0) {
      type.forEach(({ item }) => listTypes.push(item))
    }
  })

  const uniqTypes = [...new Set<string>(listTypes)]

  uniqTypes.unshift(galleryProps.filter_text_for_all_photos)

  return uniqTypes
}
